import React from 'react';
import '../../styles/money.css';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useCards } from './useCards';
import CardsDesktop from './Cards.desktop';
import CardsMobile from './Cards.mobile';

const CardsView = choose(CardsDesktop, CardsMobile);

function CardsInner({ event }) {
  const vm = useCards(event);
  return <CardsView vm={vm} />;
}

// /app/cards — the printable list of invitation-card names (one per household
// or business), taken from the guest list.
export default function Cards() {
  return <RequireEvent>{(event) => <CardsInner event={event} />}</RequireEvent>;
}
